<template>
  <div class="grant-user-button" @click="grantUser">
    <a class="grant-user-text">
      {{
        isBroadcaster ? $t('community.grantUserForBroadcast.revokeBroadcaster') : $t('community.grantUserForBroadcast.addBroadcaster')
      }}
    </a>
  </div>
</template>
<script>
export default {
  name: 'GrantUserForBroadcast',
  props: {
    communityId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    isBroadcaster: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    grantUser() {
      if (!this.isBroadcaster) {
        this.$store.dispatch('grantUserForBroadcast', { communityId: this.communityId, userId: this.userId })
      } else {
        this.$store.dispatch('revokeUserForBroadcast', { communityId: this.communityId, userId: this.userId })
      }
    }
  }
}
</script>
<style scoped lang="scss">

.grant-user-button {
  padding: 4px 6px;
  width: 100%;
  height: 100%;

  .grant-user-text {
    height: 40px;
  }

  &:hover {
    background-color: $primary-color;
    color: white;
  }
}

</style>
